<template>
    <Dropdown :expanded="expanded">
        <template slot="toggle">
            <div 
                class="toolbar-button">
                <Icon 
                    :svg="verseNumberIcon" />
                <div class="selected-option">{{ selected }}</div>
                
                <Icon
                    :svg="arrowDownIcon" 
                    class="dropdown-icon" />
            </div>
        </template>

        <template slot="list">
            <div
                v-for="option in options"
                :key="option"
                class="option"
                @click="select(option)"
            >
                {{ option }}
            </div>
        </template>
    </Dropdown>

</template>

<script>

import Icon from './Icon';
import Dropdown from './Dropdown';

import ArrowDownIcon from 'voluum-frontend-icons/arrow-down.svg';
import VerseNumberIcon from 'voluum-frontend-icons/verse-number.svg';


export default {
    name: 'RowLimitter',

    components: {
        Icon,
        Dropdown
    },

    props: {
        limit: {
            type: Number,
            required: true
        }
    },

    data: function () {
        return {
            options: [1000, 500, 200, 100, 50],
            selected: this.limit,
            expanded: { state: false },
            verseNumberIcon: VerseNumberIcon,
            arrowDownIcon: ArrowDownIcon
        };
    },

    methods: {
        select: function (option) {
            this.expanded = { state: false };
            this.selected = option;
            
            this.$store.commit('setLimit', option);
            this.$store.commit('setPage', 1);
            this.$store.dispatch('loadReport');
        }
    }
};
</script>

<style lang="less" scoped>

    @import "../styles/colors.less";
    @import "../styles/globals.less";

    .row-limitter {
        display: inline-flex;
    }

    .option {
        padding: 6px 8px;
        cursor: pointer;
        text-align: left;
        background-color: @color-white;
    }

    .option:hover {
        background-color: @dropdown-option-hover-blue;
    }

    .option + .option {
        border-top: 1px solid @border-grey;
    }

    .selected-option {
        margin-left: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/RowLimitter.vue